import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';

import { IrisTextInputComponent } from './text-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedFormPipesModule,
    NgxMaskDirective
  ],
  declarations: [
    IrisTextInputComponent
  ],
  exports: [
    IrisTextInputComponent
  ],
  providers: [
    provideNgxMask()
  ]
})

export class IrisTextInputModule {}
